import { useEffect, useState } from "react";
import { decodeUrl } from "../../helperFunctions";
import { useAppSelector } from "../../redux/hooks";

export const ProfilePicture = ({
  className,
  tempSrc,
  initials,
}: {
  className?: string;
  tempSrc?: string;
  initials?: string;
}) => {
  const [profileBgColor, setProfileBgColor] = useState("");
  const [image, setImage] = useState<string>();
  const [imgError, setImgError] = useState(false);

  const profile = useAppSelector((state) => {
    return state.auth.profile;
  });

  useEffect(() => {
    const colors = ["!bg-[#F1D7FD] !border-[#F1D7FD]"];
    const random = Math.floor(Math.random() * colors.length);
    setProfileBgColor(colors[random]);
  }, []);

  useEffect(() => {
    if (profile?.type === "cooperative") {
      setImage(profile?.logo || "/assets/images/profile.svg");
    } else {
      setImage(profile?.Picture || "/assets/images/profile.svg");
    }
  }, [profile]);

  useEffect(() => {
    setImgError(false);
  }, [tempSrc, image]);

  // When `initials` is passed, this avatar represents someone other than the
  // logged-in user, so it must never fall back to the logged-in user's own picture.
  const isOtherProfile = initials !== undefined;
  const src = tempSrc || (isOtherProfile ? undefined : decodeUrl(image));
  const showImage = !imgError && !!src;

  return (
    <div
      className={`
        relative w-[32px] h-[32px] min-w-[32px]
        border border-light-grey
        rounded-full overflow-hidden ${!showImage && profileBgColor}
        text-pry-dark-green-400 text-xs text-center font-medium uppercase
        flex items-center justify-center
        ${className}
        `}
    >
      {showImage ? (
        <img
          src={src}
          alt="profile"
          className="w-full h-full object-cover rounded-full"
          onError={() => setImgError(true)}
        />
      ) : (
        <>
          {initials ??
            (profile?.type === "member"
              ? `${profile?.FirstName?.slice(0, 1)}${profile?.LastName?.slice(
                  0,
                  1
                )}`
              : profile?.CoopName?.slice(0, 1))}
        </>
      )}
    </div>
  );
};
